import { SEND_TO_SMS, SEND_TO_EMAIL } from './consts';

/**
 * Determines OTP delivery eligibility based on user contact info and FSP config.
 * @param {object} userInfo - from oneTimePasscodeInfo selector
 * @param {object} fspOtpConfig - from otpConfig selector
 * @returns {{ canSend, canSendSms, canSendEmail, defaultSendTo, useGenerateFallback }}
 */
function getDeliveryEligibility(userInfo, fspOtpConfig) {
  const smsOnly = fspOtpConfig?.otpSmsOnlyOffOn === 'on';
  const hasEmail = Boolean(userInfo?.email);
  const hasSms = Boolean(userInfo?.mobilePhone);

  const canSendEmail = hasEmail && !smsOnly;
  const canSendSms = hasSms;

  const canSend = canSendSms || canSendEmail;

  const defaultSendTo = canSendSms ? SEND_TO_SMS : SEND_TO_EMAIL;

  const useGenerateFallback = !canSend;

  return {
    canSend,
    canSendSms,
    canSendEmail,
    defaultSendTo,
    useGenerateFallback,
  };
}

export { getDeliveryEligibility };
export default getDeliveryEligibility;
